
import React, { useEffect, useRef, useState } from 'react'

import { P, SectionHeading, SectionMainWrapper, SectionSmallHeading, SectionSubHeading, SectionWrapper, Text } from "../../Styles/style";

import DoneAllIcon from '@mui/icons-material/DoneAll';
import uniswap from "../../../assets/images/twitter.png"
import dextools from "../../../assets/images/telegram.png"
import styled from "@emotion/styled";
import { Container, Grid, useTheme } from "@mui/material";
import arbvideo from "../../../assets/images/mainanim.png"
import heading from "../../../assets/images/heading.png"

import copy from "../../../assets/images/copy.png"
const VideoBK = styled.img`
  width: 100%;
  height: auto;
  max-width: 670px;
`;
const GridHEading = styled(Grid)`
padding: 0 0;
display: flex;
/* align-items: center; */
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const GridVideo = styled(Grid)`
/* mix-blend-mode: lighten; */

display: flex;
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;

@media screen and (max-height:699px){
  padding: 150px 0 0;
}

@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-right: 10px;
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "100PX")};

 }
`

const BuyNow = styled.a`
text-decoration: none;
background: linear-gradient(-90deg, rgb(0, 234, 255) 14%, rgb(0, 128, 257) 30%, rgb(0, 128, 255) 20%, rgb(128, 0, 255) 57%, rgb(230, 25, 230) 89%);
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 8px;
padding: 12px 25px;
font-family:'P-B';
margin-right: 15px;
@media screen and (max-width:399px){
  padding: 8px 20px;

}
`
const View = styled.a`
text-decoration: none;
background: transparent;
border:1px solid #fff;
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 8px;
padding: 12px 25px;
font-family:'P-B';
margin-right: 15px;
@media screen and (max-width:399px){
  padding: 8px 20px;

}
`
const HeadingImg = styled.img`
width:100%;
height:auto;
/* max-width:200px; */
`

const Textarea = styled.textarea`
 font-size: 17px;
 resize: none;
font-family: "P-SB";
 overflow: hidden;
 color:#fff;
 border: none;
 width:500px;
 /* width:380px; */
 background: transparent;
 text-align: -webkit-center;
 text-align: -moz-center;
 outline: none;

 `;
const ContractAdd = styled.span`
 word-break: keep-all;
border:1px solid #fff;
 width:100%;
 max-width:80%;
 border-radius: 20px;;
 display: flex;
 justify-content: space-between;
 align-items: flex-start;
 padding:10px 30px;
 height:60px;
 @media screen and (max-width: 1350px) {
   height:80px;
 }
 @media screen and (max-width: 600px) {
   height:90px;
   max-width:100%;
 }
 `;
const Section1_Header = () => {
  const [copySuccess, setCopySuccess] = useState("");
  const textAreaRef = useRef(null);


  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
    setCopySuccess(<DoneAllIcon style={{ fill: "#fff" }} />);
  }
  useEffect(() => {
    setTimeout(() => {
      setCopySuccess('')
    }, 2000)
  }, [copySuccess]);
  const theme = useTheme()
  return (
    <SectionMainWrapper p="0rem 0" id="home">
      <Container maxWidth="xl">

        <GridHEading container >

          <GridImage xs={12} md={6}>
            {/* <HeadingSec>
              Richard Heart Parody
  </HeadingSec> */}
            <HeadingImg src={heading} />

            <P
              maxWidth="80%"
              p="0 0 20px 0"
              m="0"

              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0"
            >
              Welcome to the official website of Richard Heart Parody, the meme token that follows the founder of the Pulse chain network, Richard Heart. Experience a crypto journey filled with amusement as we share some of the most killer and amazing memes out there!</P>
            <div data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-duration="500"
              data-aos-offset="0"
            >
              <br />
              <br />
              <BuyNow
                href="https://app.pulsex.com/swap?outputCurrency=0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d"
                target="_blank">
                Buy Now
              </BuyNow>
              <View bgColor="#8204F0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="700"
                data-aos-offset="0"
                href="https://www.dextools.io/app/en/pulse/pair-explorer/0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d"
                target="_blank">
                View Chart
              </View>
            </div>

            <br />
            <br />
            <ContractAdd>
              <Textarea ref={textAreaRef} value="0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d" />
              <img
                onClick={copyToClipboard}
                style={{ cursor: "pointer" }}
                src={copy}
              />
              {copySuccess}
            </ContractAdd>
            {/* <div style={{ display: "flex", alignItems: "center" }}>
              <SectionSmallHeading p="40px 0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-duration="400"
                data-aos-offset="0">Follow us:</SectionSmallHeading>
              <a href="https://twitter.com/pulsepepecoin"  target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1100"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={uniswap} />
              </a>
              <a href="https://t.me/pulsepepejoin" target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1200"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={dextools} />
              </a>
            </div> */}
          </GridImage>
          <GridVideo
            xs={12}
            md={6}
            data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <VideoBK src={arbvideo} />
          </GridVideo>
        </GridHEading>
      </Container>
    </SectionMainWrapper>
  );
};

export default Section1_Header;
